import VectorLayer from 'ol/layer/Vector';
import VectorSource from 'ol/source/Vector';
import MapInstance from 'ol/Map';
import { View } from 'ol';
import { selectStyle } from '@/assets/map/selected-styles';
import { get as getProjectionInfo } from 'ol/proj';
export const defaultSettings = {
    initialCenter: [-10997148, 4569099],
    initialZoom: 1,
    resolutions: [
        9783.939619140625, 4891.9698095703125, 2445.9849047851562, 1222.9924523925781, 611.4962261962891, 305.74811309814453,
        152.87405654907226, 76.43702827453613, 38.218514137268066, 19.109257068634033, 9.554628534317017, 4.777314267158508, 2.388657133579254,
        1.194328566789627, 0.5971642833948135, 0.2985821416974068, 0.1492910708487034, 0.0746455354243517,
    ],
    webMercatorExtent: getProjectionInfo('EPSG:3857')?.getExtent(),
};
export function initMap(target, view, layers) {
    const map = new MapInstance({
        target: target,
        view: view,
        layers: layers,
        controls: [],
    });
    return map;
}
export function initView() {
    const view = new View({
        center: defaultSettings.initialCenter,
        zoom: defaultSettings.initialZoom,
        resolutions: defaultSettings.resolutions,
        constrainResolution: true,
    });
    return view;
}
export function initSelectionLayer() {
    const selectionLayer = new VectorLayer({
        source: new VectorSource({
            features: [],
        }),
        style: selectStyle,
    });
    selectionLayer.setZIndex(100);
    return selectionLayer;
}
/* export function createWMS(layer, startDate, resolutions) {
  // Get distribution accessUrl
  let dist = this.getDist(layer, 'WMS') || this.getDist(layer, 'ArcGIS GeoServices REST API')
  /*if (dist.accessURL.includes('/MapServer/')) {
    let rest = dist.accessURL.split('/rest/')
    let distUrl = rest[0] + '/' + rest[1]
    distUrl = distUrl.split('/MapServer/')[0]
    dist = {
      accessURL: distUrl + '/MapServer/WMSServer',
      format: 'WMS',
      mediaType: 'image/png',
      title: 'WMS',
      '@type': 'dcat:Distribution',
    }
  }
  //const hosted = dist.accessURL?.includes('cast.uark.edu')

  //!! Fix sentinel start/end date
  let title = layer.title || layer.identification?.title
  if (title.includes('Sentinel')) {
    let tempTime = new Date(startDate.getTime())
    tempTime.setMonth(tempTime.getMonth() - 2)
    let time = tempTime.toISOString().substr(0, 19) + 'Z/' + startDate.toISOString().substr(0, 19) + 'Z'
    layer.required_parameters.time = time
  }

  const tileGrid = new TileGrid({
    extent: defaultSettings.webMercatorExtent,
    resolutions: resolutions,
    tileSize: [512, 512],
  })

  let keys = []
  if (layer.required_parameters) {
    keys = Object.keys(layer.required_parameters)
  }
  const yearParams = keys
    .filter((key) => key.includes('year'))
    .reduce((obj, key) => {
      obj[key] = layer.required_parameters[key]
      return obj
    }, {})
  const tableidParams = keys
    .filter((key) => key.includes('tableid'))
    .reduce((obj, key) => {
      obj[key] = layer.required_parameters[key]
      return obj
    }, {})
  let viewParams = ''
  if (Object.keys(yearParams).length || Object.keys(tableidParams).length) {
    viewParams = Object.keys(yearParams)[0]
    if (Object.keys(tableidParams).length) {
      viewParams = viewParams.concat(';', Object.keys(tableidParams)[0])
    }
  }
  const censusLayer = Object.keys(tableidParams).length > 0
  const url = censusLayer ? 'https://geoserve.cast.uark.edu/geoserver/transmap/wms' : dist.accessURL

  const params = title?.includes('Sentinel') ? layer.required_parameters : { CRS: `EPSG:${layer.extents.spatial.crs}`, SRS: `EPSG:${layer.extents.spatial.crs}`, LAYERS: dist.name || 0, TILED: true }

  const tileWMSLayer = new TileLayer({
    source: new TileWMS({
      url: url,
      params: params,
      transition: 0,
      tileGrid: tileGrid,
      projection: `EPSG:${layer.extents.spatial.crs}`,
    }),
    minZoom: layer.extents?.spatial?.minzoom || 0,
    maxZoom: layer.extents?.spatial?.maxzoom || 16,
    opacity: layer.opacity || 1,
    visible: layer.visible || true,
  })
  return tileWMSLayer
} */
/*
initiateMap() {

  var vm = this
  Object.assign(this, this.config.state.settings)

  let scale = this.view.getResolution() * this.scaleDenominator
  this.config.currentScale.value = scale
  let extent = this.view.calculateExtent(this.map.getSize())
  this.config.currentExtent.value = extent

  this.mapLoaded = true

  setTimeout(() => {
    this.map.updateSize()
  }, 0)

  this.map.on('moveend', this.onMoveEnd)

  this.map.on('click', function (e) {
    var map = this
    var pixel = e.pixel
    vm.resetSelection()

    let wmsLayers = vm.map.getLayers().array_.filter((item) => item.getVisible() && item.getSource() instanceof TileWMS && !item.get('data').title.includes('Imagery'))

    let viewResolution = vm.view.getResolution()
    if (wmsLayers.length > 0) {
      for (let i = 0; i < wmsLayers.length; i++) {
        // Need a solution for arcgis layers with no returned geometry
        let url = wmsLayers[i].getSource().getFeatureInfoUrl(e.coordinate, viewResolution, 'EPSG:3857', { INFO_FORMAT: 'application/geojson', FEATURE_COUNT: 10 })
        // let url = wmsLayers[i].getSource().getFeatureInfoUrl(e.coordinate, viewResolution, 'EPSG:3857', { INFO_FORMAT: 'application/json' })
        if (url) {
          axios.get(url).then((response) => {
            if (response.data?.features?.length > 0) {
              vm.$set(vm.selected, getUid(wmsLayers[i]), response.data.features)
              vm.selectionLayer.getSource().addFeatures(new GeoJSON().readFeatures(response.data))
            }
          })
        }
      }
    }

    map.forEachFeatureAtPixel(pixel, function (f, layer) {
      if (layer !== vm.selectionLayer) {
        if (!vm.selected[getUid(layer)]) {
          vm.$set(vm.selected, getUid(layer), [])
        }
        vm.selectionLayer.getSource().addFeature(f)
        vm.selected[getUid(layer)].push(f)
      }
    })
  })
}, */
